import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 10px;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 10px;
	font-size: 12px;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	color: rgba(0, 0, 45, 0.7);
	font-size: 12px;
	background-color: rgba(255, 255, 255, 0.8);
	padding: 5px 10px;
	border-radius: 15px;
	box-shadow: 0 4px 5px -6px rgb(185, 152, 136);
`;

export const Title = styled.div``;

export const Timestamp = styled.div`
	color: rgba(0, 0, 45, 0.6);
	margin-top: 5px;
	font-size: x-small;
`;
